import React from 'react';
import { useTranslation } from '@pascal/pascal-core';
import { globalTranslationKeys } from '../../enums/translationKeys';

export const MobileResultWrapper = ({ children }) => {
  const t = useTranslation();

  return (
    <div className='pgc-result-has-last-card-holder-mobile'>
      <div className='mobileFishResultContainer'>
        <p className='mobileFishResultTitle'>{t(globalTranslationKeys.RoundId)}</p>
        {children}
      </div>
    </div>
  );
};
